<div class="board-wrapper" #boardWrapper (mousedown)="startScrollOnDrag(boardWrapper, $event)"
	(scroll)="onScroll()">
	<!-- <div class="board-wrapper" #boardWrapper (scroll)="onScroll($event)"> -->
	<div class="board-columns" cdkDropListGroup>
		<app-kanban-column *ngFor="let column of columns; trackBy: trackById" [column]="column" [device]="deviceInfo">
		</app-kanban-column>
	</div>

	<!-- <drag-scroll class="board-columns" cdkDropListGroup>
		<app-kanban-column *ngFor="let column of columns; trackBy: trackById" [column]="column" [device]="deviceInfo">
		</app-kanban-column>
	</drag-scroll> -->
</div>
